


import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    canvasContainer: {
        width: '98%',
        height:"28%",
        background:'black',
        display: 'flex',
        justifyContent: 'center',
        position:'relative',
        height:"100%",
        left:"1%",
      },
      canvas:{
          width:"100%",
          height:"60%",
          display:"block",
          backgroundColor:"black"
      }
}));

/**
 * @component WaveMonitor
 */
function WaveMonitor() {
  const classes = useStyles();
  
  return (
    <div className={classes.canvasContainer}>
        {/* <canvas id="wave" className={classes.canvas}></canvas> */}
    </div>
  );
}

export default WaveMonitor;
